(function () {
  'use strict';
  if (window.JJQuoteRegions) {
    window.JJQuoteRegions.mount();
    return;
  }
  // This preserves the existing model-interest routes, not a list of approved markets.
  var routes = { US: 'us' };
  'DE AT CH FR BE NL LU IT ES PT IE PL CZ DK SE FI NO GB'.split(' ').forEach(function (code) {
    routes[code] = 'eu';
  });
  var mounted = new WeakMap();

  function init(form) {
    if (mounted.has(form)) { mounted.get(form)(); return; }
    var country = form.querySelector('[data-jj-country]');
    var use = form.querySelector('[data-jj-use-country]');
    var language = form.querySelector('[data-jj-language]');
    if (!country || !use || !language) return;
    var detail = form.querySelector('[data-jj-country-detail]');
    var useDetail = form.querySelector('[data-jj-use-detail]');
    var review = form.querySelector('[data-jj-review]');
    var groups = form.querySelectorAll('[data-jj-models]');
    var fieldset = form.querySelector('[data-jj-model-fieldset]');
    var submitGroup = form.querySelector('[data-jj-submit-group]');
    var more = form.querySelector('.jj-quote__more');
    var supportLink = form.querySelector('[data-jj-status="support_only"] a');
    if (!detail || !useDetail || !review || !fieldset || !submitGroup || !supportLink ||
        !detail.querySelector('input') || !useDetail.querySelector('input') || !groups.length) return;
    var lastDestination;

    function sync() {
      var destination = country.value;
      var effectiveUse = use.value || destination;
      var blocked = destination === 'RU' || effectiveUse === 'RU';
      var group = !blocked && routes[destination] && routes[destination] === routes[effectiveUse]
        ? routes[destination] : '';
      var status = blocked ? 'support_only' : (!destination ? 'unverified' : (group ? 'existing_route_review' : 'pending_review'));
      var pair = destination + ':' + effectiveUse;
      var changed = lastDestination !== undefined && pair !== lastDestination;
      lastDestination = pair;
      review.value = status;
      detail.hidden = destination !== 'Other';
      detail.querySelector('input').disabled = destination !== 'Other';
      useDetail.hidden = use.value !== 'Other';
      useDetail.querySelector('input').disabled = use.value !== 'Other';
      fieldset.hidden = !group;
      Array.prototype.forEach.call(groups, function (container) {
        var show = container.getAttribute('data-jj-models') === group;
        container.hidden = !show;
        Array.prototype.forEach.call(container.querySelectorAll('input'), function (input) {
          input.disabled = !show;
          if (!show || changed) input.checked = false;
        });
      });
      if (pendingModel && destination) {
        Array.prototype.forEach.call(form.querySelectorAll('input[data-jj-model]'), function (input) {
          if (input.getAttribute('data-jj-model') === pendingModel && !input.disabled) {
            input.checked = true;
            if (more) more.open = true;
          }
        });
        pendingModel = '';
      }
      Array.prototype.forEach.call(form.querySelectorAll('[data-jj-status]'), function (notice) {
        notice.hidden = notice.getAttribute('data-jj-status') !== status;
      });
      submitGroup.disabled = blocked;
    }

    function setSelect(select, value) {
      if (!value) return;
      if (Array.prototype.some.call(select.options, function (option) { return option.value === value; })) {
        select.value = value;
      }
    }
    var params = new URLSearchParams(window.location.search);
    // Keep an old model-only link until the customer explicitly chooses a destination.
    var pendingModel = country.value ? '' : params.get('model');
    // A restored form wins over URL defaults. URL data never changes Market, Locale or Page.
    if (!country.value) setSelect(country, params.get('country'));
    if (!use.value) setSelect(use, params.get('use_country'));
    if (!language.value) setSelect(language, params.get('language'));
    sync();
    var qty = form.querySelector('[name="contact[Quantity radios]"]');
    var quantity = params.get('qty');
    if (qty && !qty.value && /^[1-9]\d{0,5}$/.test(quantity || '')) qty.value = quantity;
    var industry = form.querySelector('[name="contact[Industry]"]');
    if (industry && !industry.value) setSelect(industry, params.get('industry'));
    if (more && (use.value || language.value || (qty && qty.value && more.contains(qty)) || (industry && industry.value))) {
      more.open = true;
    }
    form.addEventListener('invalid', function (event) {
      if (more && more.contains(event.target)) more.open = true;
    }, true);
    country.addEventListener('change', sync);
    use.addEventListener('change', sync);
    form.addEventListener('reset', function () { pendingModel = ''; window.setTimeout(sync, 0); });
    // A scripted submit must obey the same Russia boundary as the visible button.
    form.addEventListener('submit', function (event) {
      sync();
      if (review.value === 'support_only') {
        event.preventDefault();
        supportLink.focus();
      }
    });
    mounted.set(form, sync);
  }
  function mount() {
    document.querySelectorAll('form[data-jj-regions]').forEach(init);
  }
  window.JJQuoteRegions = { mount: mount };
  document.addEventListener('DOMContentLoaded', mount);
  document.addEventListener('shopify:section:load', mount);
  window.addEventListener('pageshow', mount);
  mount();
})();
